const {h, render, Component} = require('preact');

class InfiniteScroll extends Component {
  constructor(props) {
    super(props)
    this.handleScroll = this.handleScroll.bind(this)
  }

  componentDidMount() {
    document.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount () {
    document.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll() {
    var element = document.body
    if (element) {
      var scrollTop = element.scrollTop
      var scrollHeight = element.scrollHeight
      var clientHeight = element.offsetHeight
      var scrolledToBottom = Math.ceil(scrollTop + clientHeight) >= scrollHeight
      if (scrolledToBottom && this.props.hasMore) {
        this.props.loadMore(this.props.currentPage += 1)
      }
    }
  }

  render() {
    var childrenList = [this.props.children]
    return (
      <div>
        {childrenList}
      </div>
    )
  }
}

module.exports = InfiniteScroll